import React, { useState } from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import {
  FDBodyText,
  FDDialog,
  FDDialogContent,
  FDDialogTitle,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import RemainingFieldList from 'Components/UI/Meta/MetaForm/Components/MetaLayout/RemainingFieldList';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useSnackbarContext } from 'Context/SnackbarContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import RichTextField from 'Components/ComponentLibrary/Molecules/RichTextField';

const metaOverrideSet = fr.metaOverride({ base: BaseOverrideNoHidden })
  .override({ hint: 'richtext' }, {
    _component: () => RichTextField,
    _customProps: {
      customConfig: { height: 200 },
    },
  });

const DialogContent = () => {
  const { onSubmit } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = useState(false);

  const handleOnClick = async () => {
    try {
      setLoading(true);
      await onSubmit();
    } catch (err) {
      displayErrorMessage('Failed to send message about action item.');
    }
    setLoading(false);
  };

  return (
    <FDStack direction={'column'} spacing={2}>
      <MetaField attr="question" placeholder="I saved more than expected last month, is this action still right?" />
      <RemainingFieldList />
      <FDPrimaryActionButton
        size={'md'}
        label={'Submit'}
        isFullWidth
        onClick={handleOnClick}
        loading={loading}
      />
    </FDStack>
  );
};

const ActionItemQuestionDialog = ({
  onClose, openModal, resource,
}) => {
  const isMobile = useMobileLayout();
  const { displaySuccess } = useSnackbarContext();
  if (!resource) {
    return null;
  }

  const handleSubmit = () => {
    onClose();
    displaySuccess('Your message has been sent and your planner will review and respond shortly.');
  };

  return (
    <FDDialog
      onClose={onClose}
      open={openModal}
      fullScreen={isMobile}
    >
      <FDDialogTitle value={'Ask My Planner'} />
      <FDDialogContent>
        <FDStack direction="column" spacing={1}>
          <FDBodyText
            value={'Ask your planner a question or let them know if anything has changed that would affect this action.'}
          />
          <MetaFormInline
            noIndividualSubmitButtons
            metaOverrideSet={metaOverrideSet}
            layout={DialogContent}
            resource={resource}
            onSubmit={handleSubmit}
            margin={'none'}
            padding={'none'}
          />
        </FDStack>
      </FDDialogContent>
    </FDDialog>
  );
};

ActionItemQuestionDialog.defaultProps = {
  openModal: false,
  resource: null,
};

ActionItemQuestionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  openModal: PropTypes.bool,
  resource: PropTypes.object,
};

export default ActionItemQuestionDialog;
